class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.addListeners();

    this.drawer = document.querySelector(".drawer--mini-cart");
    this.cartCounters = document.querySelectorAll('.js-cart-counter');
  }

  cartAddUnsubscriber = undefined;
  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartAddUnsubscriber = subscribe(PUB_SUB_EVENTS.cartAdd, () => {
      this.renderCart();

      if (!this.drawer.classList.contains("drawer--active")) {
        this.drawer.dispatchEvent(new Event("drawer-toggle"));
      }
    });

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.renderCart();
    });
  }

  disconnectedCallback() {
    if (this.cartAddUnsubscriber) this.cartAddUnsubscriber();
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  handleInputChange(input, key) {
    this.classList.add("mini-cart--loading");

    let lineKey = key;
    let quantity = 0;

    if (input && input.getAttribute("data-key")) {
      lineKey = input.getAttribute("data-key");
    }

    if (input && input.value) quantity = parseInt(input.value);

    if (lineKey && quantity >= 0) {
      const body = JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: "mini-cart",
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then(response => response.status === 200 ? response.text() : response.json())
        .then(text => {
          if (text.errors){
            alert(text.errors)
            this.renderCart();
          } else {
            const sectionHtml = JSON.parse(text).sections["mini-cart"];
            this.renderCart(sectionHtml);
          }
        })
        .catch(e => console.error(e));
    } else {
      this.classList.remove("mini-cart--loading");

      console.error("No line item details");
    }
  }

  renderCart(html) {
    this.classList.add("mini-cart--loading");

    if (html) {
      this.querySelector(".js-mini-cart-items").innerHTML = html;
      this.postRenderFunctions();
    } else {
      fetch("/?sections=mini-cart-items,temp-mini-cart-footer,cart-delivery")
        .then(response => response.text())
        .then(response => {
          const parsed = JSON.parse(response);
          const cartItems = parsed["mini-cart-items"];
          const cartFooter = parsed["temp-mini-cart-footer"];
          const cartDelivery = parsed["cart-delivery"];
          const oldCartItems = this.querySelector(".js-mini-cart-items");
          const oldCartFooter = document.querySelector(".js-mini-cart-footer");
          const oldCartDelivery = document.querySelector(".js-cart-delivery");

          oldCartItems.innerHTML = cartItems;
          oldCartFooter.innerHTML = cartFooter;
          if (oldCartDelivery && cartDelivery !== undefined) oldCartDelivery.innerHTML = cartDelivery;

          this.postRenderFunctions();
        });
    }
  }

  postRenderFunctions() {
    this.classList.remove("mini-cart--loading");

    this.addListeners();
    this.updateTotal();
  }

  addListeners() {
    this.miniCartForm = this.querySelector("form");

    if (this.miniCartForm) {
      this.quantityInputs = this.miniCartForm.querySelectorAll(".js-mini-cart-quantity");
      this.removeButtons = this.miniCartForm.querySelectorAll(".js-cart-remove");

      if (this.quantityInputs) {
        this.quantityInputs.forEach(input =>
          input.addEventListener("change", this.handleInputChange.bind(this, input))
        );
      }

      if (this.removeButtons) {
        this.removeButtons.forEach((input) =>
          input.addEventListener("click", event => {
            event.preventDefault();

            this.handleInputChange(null, input.getAttribute("data-key"));
          })
        );
      }
    }
  }

  updateTotal() {
    const totalElements = document.querySelectorAll(".js-mini-cart-total");
    const cartTotal = document.getElementById("cart-total-hidden");
    const quantity = cartTotal.getAttribute("data-cart-quantity");


    if (totalElements && cartTotal) {
      totalElements.forEach(el => el.innerHTML = cartTotal.innerHTML);
    }

    if (this.cartCounters) {
      this.cartCounters.forEach(el => el.innerHTML = quantity);
    }
  }
}

customElements.define("mini-cart", MiniCart);